import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { btn } from "@/lib/ui";

export default function NotFound() {
  useSeo({ title: "Page not found | Young Spine Tricity", description: "This page could not be found.", path: "/404", noindex: true });
  return (
    <div className="container-x py-24 text-center" data-testid="not-found">
      <p className="eyebrow justify-center">404</p>
      <h1 className="font-heading text-4xl font-extrabold text-brand-ink">Page not found</h1>
      <p className="mt-3 text-base text-slate-600">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className={`${btn("blue", "md")} mt-8`}>Go to the home page</Link>
    </div>
  );
}
